import React, { useState, useEffect } from 'react';
import { withStyles, Stepper, StepLabel, Step, Paper, Dialog, CircularProgress } from '@material-ui/core';
import moment from "moment";
import StorageForm from './StorageForm'
import { connect } from 'react-redux';
import * as Yup from 'yup';
import History from '../../../History';
import * as actions from './store/storageActions';
import { BackButton, parseURL, hasPermission } from '../../sc-utilities';
import AppLogoLoading from '../../sc-logo';

const styles = theme => ({
    root: {
        width: 'auto',
        height: 'auto',
        padding: theme.spacing(2),
        margin: theme.spacing(2),
    },
    submit: {
        backgroundColor: "transparent",
        boxShadow: "none",
        overflow: "hidden",
        alignItems: "center"
    },
    cancel: {
        width: "250px",
        margin: "10px"
    }
});

const StorageCreate = props => {
    const { activeCustomer, translations, onFetchUsers, onFetchErasureMethods, creating, classes, onCreateStorage, permissions } = props;
    const [activeStep, setActiveStep] = useState(0);
    const steps = [translations['basic_info'] || 'Basic info', translations['advanced_info'] || 'Advanced info', translations['wipe_info'] || 'Wipe info', translations['verification_info'] || 'Verification info'];
    const [data, setData] = useState({ user: [], data: true, methods: [] });
    let searchParams = parseURL(window.location.search);

    const submitHandler = async data => {
        data['WipeProgress'] = data.WipeProgress && data.WipeProgress > 100 ? 100 : data.WipeProgress;
        data['VerificationProgress'] = data.VerificationProgress && data.VerificationProgress > 100 ? 100 : data.VerificationProgress;
        await onCreateStorage({ ...data, ActiveCustomerID: activeCustomer, ProductID: searchParams.productID });
        setActiveStep(0);
        History.goBack()
    }

    useEffect(() => {
        const fetchData = async () => {
            let user = await onFetchUsers({ ActiveCustomerID: activeCustomer });
            let methods = await onFetchErasureMethods({ ActiveCustomerID: activeCustomer })
            setData({ user: user, data: false, methods: methods })
        }
        fetchData();
        return () => {
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const cancelHandler = () => {
        setActiveStep(0);
        History.goBack();
    }

    const handleBack = () => {
        setActiveStep(activeStep - 1);
    };

    const handleNext = () => {
        setActiveStep(activeStep + 1);
    };

    let initialValues = {
        Type: 'storage',
        Transport: null,
        ComponentType: 'storage',
        Size: null,
        Vendor: null,
        ComponentModel: null,
        SerialNumber: null,
        LogicalName: null,
        Description: null,
        Sectors: null,
        ReallocatedSectors: null,
        HPA: null,
        DCO: null,
        OverallState: null,
        PowerOnHours: 0,
        ProgramFails: 0,
        UncorrectableErrors: 0,
        PendingSectors: 0,
        SMART: null,
        SmartScore: null,
        WipeParams: null,
        WipeResult: null,
        WipeVerify: null,
        WipeProgress: null,
        WipeStarted: moment(),
        WipeFinished: moment(),
        WipeStatus: 'noterased',
        WipeMethod: 'dod_e',
        DataWipeEmployeeID: data.user && data.user.length > 0 ? data.user[0].value : null,
        VerificationStarted: moment(),
        VerificationFinished: moment(),
        VerificationStatus: 'notverified',
        VerificationMethod: 'dod_e',
        DataVerificationEmployeeID: data.user && data.user.length > 0 ? data.user[0].value : null
    };

    let formSettings = {
        Validation: activeStep === 0 ? {
            Type: Yup.string().required('Required'),
            Size: Yup.number().required('Required'),
            Vendor: Yup.string().required('Required'),
            ComponentModel: Yup.string().required('Required'),
            SerialNumber: Yup.string().required('Required'),
            LogicalName: Yup.string().required('Required')
        } :
        activeStep === 1 ? {
            Sectors: Yup.string().required('Required'),
            ReallocatedSectors: Yup.string().required('Required'),
            SmartScore: Yup.number().max(100).min(0),
        } : 
        activeStep === 2 ? {
            WipeStatus: Yup.string().required('Required'),
            WipeMethod: Yup.string().required('Required'),
            DataWipeEmployeeID: Yup.string().required('Required')
        } : {
            VerificationStatus: Yup.string().required('Required'),
            VerificationMethod: Yup.string().required('Required'),
            DataVerificationEmployeeID: Yup.string().required('Required')
        },
        ButtonSubmit: hasPermission(permissions, "component_create") ? {
            Title: translations['save'] || 'SAVE',
            Color: 'primary'
        } : null,
        ButtonCancel: {
            Title: translations['cancel'] || 'CANCEL',
            handleCancel: cancelHandler
        },
        ButtonBack: {
            Title: translations['back'] || 'BACK',
            Color: 'primary',
            handleBack: handleBack
        },
        ButtonNext: {
            Title: translations['next'] || 'NEXT',
            Color: 'primary',
            handleNext: handleNext
        }
    };


    return <Paper className={classes.root}>
        {BackButton(translations)}
        <Dialog disableBackdropClick={true} disableEscapeKeyDown={false} open={data.data}
            PaperProps={{
                classes: {
                    root: classes.submit
                }
            }} >

            <AppLogoLoading />
        </Dialog>
        {!data.data ? <>
            <Stepper activeStep={activeStep} alternativeLabel>
                {steps.map((label, index) => {
                    return (
                        <Step key={label}>
                            <StepLabel>{label}</StepLabel>
                        </Step>
                    );
                })}
            </Stepper>
            <StorageForm reportInformation={data.user} methods={data.methods} loading={creating} handleSubmit={submitHandler} activeStep={activeStep} initialValues={initialValues} translations={translations} formSettings={formSettings} ></StorageForm>
        </>
            : <CircularProgress
                variant="static"
                color="primary"
                size={28}
            />}
    </Paper>
}

const mapStateToProps = state => {
    return {
        activeCustomer: state?.core?.login?.activeCustomer?.CustomerID ?? null,
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
        creating: state.billing.plans.creating,
        permissions: state?.core?.login?.permissions || []
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onCreateStorage: billingPlan => dispatch(actions.createStorage(billingPlan)),
        onFetchUsers: (user) => (dispatch(actions.fetchUsers(user))),
        onFetchErasureMethods: (user) => (dispatch(actions.fetchErasureMethod(user)))

    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(StorageCreate));
